<!-- Il loading panel deve stare prima di tutto per poter funzionare -->
<lp-loading-panel *ngIf="isLoading$ | async as isLoading"></lp-loading-panel>
<router-outlet></router-outlet>
